export interface IPasswords {
    password: string;
    repeatedPassword: string;
}
